import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link, NavLink, useNavigate } from "react-router-dom";
import fmeLogo from "../../images/fmeLogo.png";
import homeIcon from "../../images/homeIcon.svg";
import calendarIcon from "../../images/calendarIcon.svg";
import checkIcon from "../../images/checkIcon.svg";
import clockIcon from "../../images/clockIcon.svg";
import fileIcon from "../../images/fileIcon.svg";
import logOutIcon from "../../images/logOutIcon.svg";
import { Path } from "../../RoutesUtils";

const navigation = [
  { name: "Dashboard", href: "/", img: homeIcon },
  { name: "Planlægger", href: Path.scheduler, img: calendarIcon },
  { name: "To-do lister", href: Path.toDoList, img: checkIcon },
  { name: "Ur", href: Path.clock, img: clockIcon },
  { name: "Recept", href: Path.prescription, img: fileIcon },
];

export default function Header() {
  const navigate = useNavigate();
  const logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    navigate(Path.login);
  };

  return (
    <Disclosure as="nav">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="relative flex h-16 items-center justify-between pt-3">
          <div className="absolute inset-y-0 left-0 flex items-center lg:hidden">
            <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-white focus:ring-2 focus:ring-white focus:outline-hidden focus:ring-inset bg-green">
              <span className="absolute -inset-0.5" />
              <span className="sr-only">Open main menu</span>
              <Bars3Icon
                aria-hidden="true"
                className="block size-6 group-data-open:hidden"
              />
              <XMarkIcon
                aria-hidden="true"
                className="hidden size-6 group-data-open:block"
              />
            </DisclosureButton>
          </div>
          <div className="flex flex-1 items-center justify-center lg:items-stretch lg:justify-start">
            <div className="flex shrink-0 items-center">
              <Link to="/">
                <img
                  alt="Your Company"
                  src={fmeLogo}
                  className="w-full h-[65px]"
                />
              </Link>
            </div>
            <div className="hidden m-auto lg:block">
              <div className="flex space-x-4">
                {navigation.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.href}
                    className={({ isActive }) =>
                      `rounded-full px-3 py-2 text-sm font-semibold flex items-center gap-x-1 transition ${
                        isActive ? "bg-green text-white" : "text-green"
                      }`
                    }
                  >
                    {({ isActive }) => (
                      <>
                        <img
                          src={item.img}
                          className={`h-5 w-5 transition ${
                            isActive ? "brightness-[999]" : ""
                          }`}
                          alt={item.name}
                        />
                        {item.name}
                      </>
                    )}
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 lg:static lg:inset-auto lg:ml-6 lg:pr-0">
            <a
              style={{ cursor: "pointer" }}
              className="text-[#F02B2B] flex items-center gap-x-1 font-semibold"
              onClick={logOut}
            >
              <img src={logOutIcon} alt="Logout" />
              Log ud
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <DisclosurePanel className="lg:hidden mt-8 border-t pt-5">
        <div className="space-y-1 px-4 pt-2 pb-3">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `rounded-full px-3 py-2 text-sm font-semibold flex items-center gap-x-1 transition ${
                  isActive ? "bg-green text-white" : "text-green"
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}
        </div>
      </DisclosurePanel>
    </Disclosure>
  );
}
